import React from "react";
import { Info } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { getAddonInfo } from "@/lib/creditAddons";

/** ⓘ gomb — kattintásra magyarázat (nem aktiválja a szülő gombot). */
export function AddonInfoButton({ addonKey, testid, className = "" }) {
  const info = getAddonInfo(addonKey);
  if (!info?.help) return null;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testid || `addon-info-${addonKey}`}
          aria-label={`${info.label} – részletes leírás`}
          onClick={(e) => e.stopPropagation()}
          onPointerDown={(e) => e.stopPropagation()}
          className={`inline-flex shrink-0 items-center justify-center w-5 h-5 rounded-full border border-white/25 text-slate-400 hover:text-white hover:border-electric/50 hover:bg-white/5 transition-colors ${className}`}
        >
          <Info className="w-3 h-3" strokeWidth={2} />
        </button>
      </PopoverTrigger>
      <PopoverContent
        className="z-[100] w-[min(20rem,calc(100vw-2rem))] bg-anthracite-800 border-white/10 text-slate-200 p-4 shadow-xl"
        align="start"
        side="top"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <div className="text-sm font-medium text-white mb-2">{info.helpTitle || info.label}</div>
        <p className="text-xs text-slate-300 leading-relaxed whitespace-pre-line">{info.help}</p>
      </PopoverContent>
    </Popover>
  );
}
